import React from 'react';

const Spedizione = () => {
  return (
    <svg
      version="1.1"
      id="spedizione_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 42 42"
      style="enable-background:new 0 0 42 42;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeMiterlimit: 10,
        verticalAlign: 'middle',
      }}
    >
      <g>
        <path d="M26.62,15.01h6.82c0.57,0,1.1,0.28,1.42,0.75l2.92,5.26h0.86c0.97,0,1.72,0.64,1.72,1.9v5.83 c0,0.95-0.77,1.72-1.72,1.72h-1.72" />
        <polyline points="12.02,9 26.62,9 26.62,30.47 13.74,30.47" />
        <line x1="6.87" y1="30.47" x2="2.58" y2="30.47" />
        <path d="M36.92,31.33c0,1.89-1.54,3.43-3.44,3.43c-1.9,0-3.44-1.53-3.44-3.43c0-1.89,1.54-3.43,3.44-3.43	C35.38,27.91,36.92,29.44,36.92,31.33z" />
        <path d="M13.75,31.33c0,1.89-1.54,3.43-3.44,3.43s-3.44-1.53-3.44-3.43c0-1.89,1.54-3.43,3.44-3.43	S13.75,29.44,13.75,31.33z" />
        <line x1="26.62" y1="30.47" x2="30.05" y2="30.47" />
        <polyline points="28.34,21.88 34.35,21.88 34.35,21.02 32.63,18.44" />
        <line x1="0" y1="19.3" x2="14.6" y2="19.3" />
        <line x1="6.87" y1="14.15" x2="19.75" y2="14.15" />
        <line x1="5.15" y1="14.15" x2="3.43" y2="14.15" />
        <line x1="10.3" y1="9" x2="8.59" y2="9" />
      </g>
    </svg>
  );
};

export default Spedizione;
